<template>
  <div class="box">
    <!-- 职位展示 -->
    <!-- 循环生成职位数据展示 -->
    <div v-for="(item, index) in listArr" :key="index">
      <div class="Position-body firm-clickable" @click="handelClick(item)">
        <!-- 兼职/全职 -->
        <div
          class="multi-disciplinary"
          :class="item.jobTypeName == '兼职' ? 'Part-time-job' : 'full-time'"
        ></div>
        <!-- 第一列职位名学历年限技能 -->
        <div class="Data-container">
          <div class="line-box">
            <p class="line-box-name">{{ item.positionName }}</p>
            <p class="line-box-demand">
              {{ item.workExperienceName }} | {{ item.educationName }}
            </p>
          </div>
          <div class="line-box"></div>
          <div class="line-box" style="width: 350px; overflow: hidden">
            <div
              class="skill"
              v-for="(item1, index1) in item.skillNames"
              :key="index1"
            >
              {{ item1 }}
            </div>
          </div>
        </div>
        <!-- 第二列公司logo -->
        <div class="logo">
          <!-- src="../../../../assets/imgs/logo.svg" -->
          <img :src="item.companyLogo" alt="" />
        </div>
        <!-- 第三列公司名 规模 地址 -->
        <div class="Data-container Company-name">
          <div class="line-box-overflow">{{ item.companyName }}</div>
          <div class="line-box">
            <div class="skill">
              {{ item.companySize ? item.companySize : "—" }}
            </div>
            <div class="skill">
              {{ item.industryTypeName ? item.industryTypeName : "—" }}
            </div>
          </div>
          <div class="line-box-overflow" :title="item.companyFullAddress">
            地址：{{ item.companyFullAddress }}
          </div>
        </div>
        <!-- 第四列聊天icon -->
        <div class="chat-icon firm-clickable" @click.stop="handelChat(item)"></div>
        <!-- 第五列收藏icon -->
        <div
          :class="item.hasCollect ? 'Collect-icon' : 'NotCollect-icon'"
          @click.stop="handelCollect(item)"
        ></div>
        <!-- 第六列 薪资 -->
        <div class="pay">
          <p>{{ item.salaryRange }}</p>
        </div>
      </div>
      <!-- 点击展开职位详情 -->
      <div class="details" v-if="unfold == item.id">
        <div class="details-box">
          <div class="post-details">
            <p class="post-details-title">岗位职责：</p>
            <!-- 循环展示岗位职责 -->
            {{ listData.positionDescribe }}

            <!-- <ul v-for="(item2, index) in item.Duty" :key="index">
              {{
                item2.name
              }}
              <li v-for="(item3, index) in item2.content" :key="index">
                {{ item3.data }}
              </li>
            </ul> -->
            <!-- <p class="post-details-title Job" style="margin-top: 30px">
              任职资格：
            </p>
            <p class="Job">缺少字段</p> -->
          </div>
          <!-- 举报 / 招聘者 -->
          <div class="report">
            <div class="report-box">
              <div class="firm-clickable" @click="handelReport(item)"></div>
              <p class="firm-clickable" @click="handelReport(item)">举报</p>
            </div>
            <div class="recruiter">
              <div class="avatar">
                <img src="../../../../assets/imgs/tx4@3x.svg" alt="" />

                <p>
                  {{ listData.publishUserName }}
                </p>
                <p>
                  {{ item.publishUserPositionName }}
                </p>
                <!-- <p>{{ listData.publishCompanyName }}</p> -->
                <!-- <p>{{ item.publishUserPositionName }}</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReportWin
      :dialogReport="dialogReport"
      :type="2"
      :reportData="reportData"
      :id="listData.positionId"
      :positionName="listData.positionName"
      :code="listData.positionCode"
      :name="itemName"
      :firmId="listData.companyId"
      @handleCloseReport="handleCloseReport"
      @handleUnderstand="handleUnderstand"
    ></ReportWin>
    <!-- 索要联系方式 -->
    <ContactInformation
      :VisibleContact="VisibleContact"
      :row="rowObj"
      :DataObj="DataObj"
      @handleCloseUp="VisibleContact = false"
      @handleConContact="handleConContact"
    ></ContactInformation>
  </div>
</template>

<script>
// // 引入职位收藏的接口
import {
  addPositionCollect, // 收藏职位
  cancelPositionCollect, // 取消职位收藏
} from "../../../../assets/api/CentreCollect";
// 引入索要联系方式弹窗
import ContactInformation from "../../home/components/homes/ContactInformation.vue";
// 引入推荐职位页的接口

import {
  getPositionInfoById, // 查看职位详情
} from "../../../../assets/api/Recommended";
// 引入举报弹窗
import ReportWin from "../../../../components/report.vue";
export default {
  props: {
    listArr: {},
  },
  data() {
    return {
      list: [], // 数据列表
      unfold: "0", // 展开详情 关闭详情
      dialogReport: false, // 举报弹窗
      positionId: "", // 用于查询职位详情
      listData: {}, // 职位详情
      reportData: {},
      itemName: "", // 被举报职位名
      skill: ["技能1", "技能2", "技能3"],
      VisibleContact: false, //索要联系方式弹窗
      rowObj: {
        companyId: "", //公司id
        companyName: "", //企业名称
        targetPositionId: "", //职位id
        targetPositionName: "", //职位名称
      }, //数据
      DataObj: {}, //点击索要联系方式被点击职位的信息
    };
  },
  components: {
    ReportWin,
    ContactInformation,
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    //点击确认索要
    handleConContact() {
      this.$emit("Refresh");
      this.VisibleContact = false;
    },
    // --------------------------------- 请求职位详情接口 --------
    async getPositionInfoById() {
      var data = {
        data: {
          positionId: this.positionId,
        },
      };
      const res = await getPositionInfoById(data);
      if (res.code == 0) {
        console.log(res.data, "4545454454");
        this.listData = res.data;
      } else {
        // this.$tool.PromptBox("error", res.msg);
      }
    },
    // 举报
    handelReport(item) {
      console.log(item, "item");
      this.itemName = item.positionName;
      this.reportData = item;
      this.dialogReport = true;
    },
    // 关闭弹窗
    handleCloseReport() {
      this.dialogReport = !this.dialogReport;
    },
    // 弹窗确定
    handleUnderstand() {
      this.dialogReport = !this.dialogReport;
    },
    // 点即时聊天
    handelChat(item) {
      this.DataObj = item;
      console.log(item, "聊天");
      this.rowObj.companyId = item.companyId;
      this.rowObj.companyName = item.companyName;
      this.rowObj.targetPositionId = item.id;
      this.rowObj.targetPositionName = item.positionName;

      if (
        this.$store.getters.getUser.id != "" &&
        this.$store.getters.getUser.id != undefined
      ) {
        // 正常
        this.VisibleContact = true;
      } else {
        // 未登录提醒登录
        this.$tool.PromptBox("warning", "请先登录！");
      }
    },
    // 点击收藏icon
    handelCollect(item) {
      // 参数
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
          positionId: item.id,
        },
      };
      if (item.hasCollect == true) {
        // 调用接口
        cancelPositionCollect(data).then((res) => {
          if (res.code == 0) {
            // 成功 改变图标样式
            this.$tool.PromptBox("success", "操作成功");
            item.hasCollect = false;
          } else {
            // 失败
            // this.$tool.PromptBox("error", res.msg);
          }
        });
      } else {
        if (
          this.$store.getters.getUser.id != "" &&
          this.$store.getters.getUser.id != undefined
        ) {
          // 调用接口
          addPositionCollect(data).then((res) => {
            if (res.code == 0) {
              // 成功 改变图标样式
              this.$tool.PromptBox("success", "收藏成功");
              item.hasCollect = true;
            }
          });
        } else {
          this.$tool.PromptBox("warning", "请先登录！");
        }
      }
    },
    // 点击展开职位详情
    handelClick(num) {
      this.positionId = num.id;
      this.getPositionInfoById();
      if (this.unfold == num.id) {
        this.unfold = "0";
      } else {
        this.unfold = num.id;
      }
    },
  },
};
</script>

<style scoped lang="less">
// 筛选区
.box {
  width: 100%;
  height: 100%;
  cursor: pointer;
  .Position-body:hover {
    box-shadow: 0px 0px 6px 1px rgba(50, 145, 248, 0.8);
  }
  .Position-body {
    width: 100%;
    height: 90px;
    margin-top: 20px;
    font-size: 14px;
    position: relative;
    display: flex;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    // 全职
    .multi-disciplinary {
      width: 30px;
      height: 20px;
      position: absolute;
    }
    // 兼职
    .Part-time-job {
      background-image: url("../../../../assets/imgs/jianzhi@3x.svg");
      background-size: 100% 100%;
    }
    // 全职
    .full-time {
      background-image: url("../../../../assets/imgs/quanzhi@3x.svg");
      background-size: 100% 100%;
    }

    .Data-container {
      width: 350px;
      height: 74px;
      margin-left: 50px;
      padding: 8px 0px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      font-family: PingFangSC-Medium;
      font-weight: 400;
      // 职位名称 / 年限学历
      .line-box {
        width: 350px;
        height: 20px;
        line-height: 20px;
        display: flex;
      }
      .line-box-overflow {
        width: 350px;
        height: 20px;
        line-height: 20px;
        font-size: 13px;
        margin: auto;
        display: flex;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .line-box-name {
        // min-width: 90px;
        width: 300px;
        font-size: 16px;
        color: #409eff ;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .line-box-demand {
        width: 130px;
        font-size: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      // 技能
      .skill {
        min-width: 50px;
        padding-left: 5px;
        padding-right: 5px;
        height: 20px;
        background: #eeeeee;
        border-radius: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 10px;
        font-size: 12px;
        color: #333333;
        text-align: center;
      }
    }

    // 公司名 地址
    .Company-name {
      margin-left: 20px;
      .line-box {
        width: 300px;
      }
    }
    // 公司logo  div
    .logo {
      width: 50px;
      height: 50px;
      margin: auto;
      margin-left: 25px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 聊天icon
    .chat-icon {
      width: 30px;
      height: 25px;
      margin: auto;
      margin-left: 20px;
      background-image: url("../../../../assets/imgs/buzaixiangoutong@3x.svg");
      background-size: 100% 100%;
    }
    // 未收藏icon
    .NotCollect-icon {
      width: 30px;
      height: 25px;
      margin: auto;
      margin-left: 20px;
      background-image: url("../../../../assets/imgs/shoucang-null@3x.svg");
      background-size: 100% 100%;
    }
    // 收藏 icon
    .Collect-icon {
      width: 30px;
      height: 25px;
      margin: auto;
      margin-left: 20px;
      background-image: url("../../../../assets/imgs/shoucang@3x.svg");
      background-size: 100% 100%;
    }
    // 薪资div
    .pay {
      flex: 1;
      margin-right: 20px;
      display: flex;
      justify-content: flex-end;
      p {
        margin: auto 0;
        font-family: PingFang-SC-Bold;
        font-size: 16px;
        color: #fe574a;
        text-align: right;
        font-weight: 700;
      }
    }
  }
  // 点击展开 职位详情
  .details {
    width: 1136px;
    min-height: 380px;
    background: #eeeeee;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 0px 0px 20px 20px;
    margin: 0 auto;
    display: flex;
    font-family: PingFangSC-Medium;
    font-weight: 400;
    .details-box {
      flex: 1;
      margin: 30px 30px 50px 30px;
      display: flex;
      // 左侧 职责
      .post-details {
        width: 70%;
        font-size: 12px;
        color: #333333;
        line-height: 20px;
      }
      .Job {
        // margin-top: 20px;
      }
      .post-details-title {
        font-size: 14px;
        color: #333333;
      }
      ul {
        margin-top: 20px;
      }
      // 右侧举报
      .report {
        flex: 1;
        display: flex;
        flex-direction: column;
        .report-box {
          width: 100%;
          flex: 1;
          display: flex;
          justify-content: flex-end;
          div {
            width: 30px;
            height: 28px;
            background-image: url("../../../../assets/imgs/jinggao-L@3x.svg");
            background-size: 100% 100%;
            margin-right: 11px;
            cursor: pointer;
          }
          p {
            line-height: 28px;
            font-size: 16px;
            color: #333333;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.recruiter {
  display: flex;
  justify-content: flex-end;
  // width: 100px;
  // border: 1px solid gold;
  .avatar {
    min-width: 100px;
    display: flex;
    flex-direction: column;
    // border: 1px solid gold;
    img {
      width: 40px;
      height: 40px;
      margin: 0 auto;
    }
    p{
      text-align: center;
      font-size: 14px;
      height: 20px;
      line-height: 20px;
    }
  }
}
</style>
